export interface RegistrationCPGRequest {
  modelNumber: string;
}
